import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

/*
 * Feature flags ale Pădurii Vii. Georgiana pornește/oprește orice funcție din admin
 * (/admin/padurea). Componentele citesc `useFeature("cheie")` și se ascund dacă e oprită.
 * Implicit TOT e pornit (dacă endpoint-ul nu răspunde, nu ascundem nimic).
 */
const FeaturesContext = createContext({ features: {}, ready: false });

export function FeaturesProvider({ children }) {
  const [features, setFeatures] = useState({});
  const [ready, setReady] = useState(false);
  useEffect(() => {
    api.get("/public/features")
      .then((r) => setFeatures(r.data || {}))
      .catch(() => setFeatures({}))
      .finally(() => setReady(true));
  }, []);
  return <FeaturesContext.Provider value={{ features, ready }}>{children}</FeaturesContext.Provider>;
}

export function useFeatures() {
  return useContext(FeaturesContext).features;
}

// true dacă funcția e pornită SAU necunoscută (nu ascundem din greșeală când lipsește flag-ul)
export function useFeature(key) {
  const { features, ready } = useContext(FeaturesContext);
  if (!ready) return true;
  return features[key] !== false;
}
